import React, { useEffect } from "react";
import dataDrawingsImg from "./dataDrawingsImg.json";

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
//
import LG_Img__organic1 from "../../img_drawings/pho3_meyoko.jpg";
// Drawings
// imgBottom1
const imgMiddle1 = {
  img1: "img_drawings/republic-utopia-detail2.jpg",
  alt1: "image city Organic",
};
// imgMiddle2
const imgMiddle2 = {
  img2: "img_drawings/republic-utopia-detail4.jpg",
  alt2: "image city Organic",
};
//

const DrawingsGrid = ({ setSelectedImgDrawings }) => {
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  //
  const { img1, alt1 } = imgMiddle1;
  const { img2, alt2 } = imgMiddle2;
  //

  //
  //
  const imageCardDrawings = dataDrawingsImg;
  // console.log(imageCards);

  return (
    <>
      <section id="drawings">
        <div className="drawings___wrapper">
          {/* ---------- */}
          {/* 
          
          
          */}
          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                DRAWINGS
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> Selected Works:</h2>
              <p> 2008 | 2021</p>
            </div>
          </div>

          {/* ---------- */}
          {/* ---------- */}

          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}

                <p> Materials:</p>
                <p> Ink, Ballpoint Pen,</p>
                <p> Watercolor, Acrylic, Pencil.</p>
              </div>
              <div className="descript__row_article">
                <h1>
                  Volkanuve creates the metamorphosis of a surreal world
                  inhabited with hybrid characters and peculiar fauna.
                  <span>
                    She uses ballpoint pen, watercolor and acrylic to create
                    luxuriant forest populated with imaginary plants and bizarre
                    characters.
                  </span>{" "}
                  Executed in free hand with a fountain pen and black, china ink
                  , the artworks by Volkanuve are like secret open doorways to a
                  microcosmic wilderness populated by divine entities and
                  mythical creatures.
                </h1>
              </div>
            </div>
          </div>
          {/* 
          
          
          
          */}

          {/* HEADER Hero*/}
          {/* ------- */}
          <div className="header__heroImg">
            <div className="header__heroIm_wrapper">
              {/* img hero */}
              <div className="header__heroIm_container">
                <div className="img-box">
                  <img src={LG_Img__organic1} alt="img city mono preview" />
                </div>
              </div>{" "}
            </div>
          </div>

          {/*  
          
          
          
          */}
          {/*   Descript ROW */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}

                <p>Technic used:</p>
                <p> Pointillism, Hatching, Blending.</p>
              </div>
              <div className="descript__row_article">
                <h1>
                  Volkanuve's landscapes, fantasies, and ephemera have a minutia
                  of detail that embodies ethereal characteristics.
                  <span>
                    Further within these dreamscapes a relationship between man
                    and machine becomes evident, a fascination she often
                    juxtaposes - coalescing the organic and mechanical to form
                    whimsical narratives.
                  </span>{" "}
                  Underlying much of her work are issues in today's society and
                  a reflection of everyday interaction between
                  people…manoeuvring within the mechanics of life.
                </h1>
              </div>
            </div>
          </div>
          {/* ---------- */}
          {/* ---------- */}
          <div className="header__folio">
            {/* heading */}{" "}
            <div className="header__folio__title">
              <h1>folio</h1>
              <h2>01</h2>
            </div>
            <div className="header__folio__titleTab">
              <h3> Technic: Mixed</h3>
              <p> 2013 | 2019</p>
            </div>
          </div>
          {/* ---------- */}
          {/* ---------- */}
          {/* ---------- */}
          <div id="gallery___modal">
            {/* ------------- */}
            <div className="gallery___modal__GridWrapper">
              <motion.div
                data-aos="fade-down"
                data-aos-duration="1000"
                className="gallery___modal__container__grid"
              >
                {imageCardDrawings &&
                  imageCardDrawings.map((itemImg) => (
                    <div
                      className="gallery___modal__card"
                      key={itemImg.id}
                      onClick={() =>
                        setSelectedImgDrawings(itemImg.img1Drawings)
                      }
                    >
                      <div className="img_box">
                        <motion.img
                          data-aos="fade-up-left"
                          data-aos-duration="1000"
                          whileHover={{ scale: 1.2 }}
                          onHoverStart={(e) => {}}
                          onHoverEnd={(e) => {}}
                          src={itemImg.img1Drawings}
                          alt={itemImg.alt}
                        />
                      </div>
                      {itemImg.text2 || itemImg.text1 ? (
                        <p>
                          {itemImg.text1} <span>{itemImg.text2} </span>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
              </motion.div>
            </div>
          </div>

          {/* 
 
 

         */}

          <div className="header__folio">
            {/* heading */}{" "}
            <div className="header__folio__title">
              <h1>folio</h1>
              <h2>02</h2>
            </div>
            <div className="header__folio__titleTab">
              <h3> Archive: The republic of Utopia</h3>
              <p> 2010</p>
            </div>
          </div>
          {/* ---------- */}
          {/* DRAWINGS   */}
          {/* ---------- */}
          <div id="featuredDrawings__Scroll">
            <div className="featuredDrawings_scroll_LG_imgWrapper">
              <div className="featuredDrawings_scroll_LG_imgContainer">
                <div className="featuredDrawings_scroll_LG__description"></div>
              </div>
            </div>
          </div>
          {/* 
          
          
          
          
          */}
             {/*   Descript ROW */}
             <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}

                <p>Technic used:</p>
                <p> Pointillism, Hatching, Blending.</p>
              </div>
              <div className="descript__row_article">
                {/* <h1>
                  Vodanova's landscapes, fantasies, and ephemera have a minutia
                  of detail that embodies ethereal characteristics.
                  <span>
                    Further within these dreamscapes a relationship between man
                    and machine becomes evident, a fascination she often
                    juxtaposes - coalescing the organic and mechanical to form
                    whimsical narratives.
                  </span>{" "}
                  Underlying much of her work are issues in today's society and
                  a reflection of everyday interaction between
                  people…manoeuvring within the mechanics of life.
                </h1> */}
              </div>
            </div>
          </div>
          {/* ---------- */}
          <div id="drawings__imgMiddle">
            <div className="drawings__imgMiddle_wrapper">
              <div className="drawings__imgMiddle_container">
                <div className="boxImg">
                  <motion.img
                    data-aos="fade-up-left"
                    data-aos-duration="1000"
                    whileHover={{ scale: 1.2 }}
                    onHoverStart={(e) => {}}
                    onHoverEnd={(e) => {}}
                    src={img1}
                    alt={alt1}
                  />
                </div>
                <div className="boxImg">
                  <motion.img
                    data-aos="fade-up-left"
                    data-aos-duration="1000"
                    whileHover={{ scale: 1.2 }}
                    onHoverStart={(e) => {}}
                    onHoverEnd={(e) => {}}
                    src={img2}
                    alt={alt2}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* 
             
             
             
                 whileHover={{
                            scale: 1.2,
                            transition: { duration: 1 },
                          }}
                          whileTap={{ scale: 0.9 }}   
             
             
             - */}
        </div>
      </section>
    </>
  );
};

export default DrawingsGrid;
